// Global Currency Configuration
export const CURRENCY_CONFIG = {
    code: 'GHS',
    symbol: 'GHS',
    name: 'Ghana Cedi'
};

// Currency formatting utility function
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined || isNaN(Number(amount))) {
    return `${CURRENCY_CONFIG.symbol} 0.00`;
  }
  const formattedNumber = Number(amount).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${CURRENCY_CONFIG.symbol} ${formattedNumber}`;
};